import { levelOptions, durationOptions, priceTypeOptions } from '@/utils/course';

export interface CategoryFilterState {
  sub: string;
  level: string;
  duration: string;
  price: string;
}

interface CategoryFilterProps {
  subcategories: string[];
  state: CategoryFilterState;
  onSelect: (group: keyof CategoryFilterState, value: string) => void;
  onReset: () => void;
}

function FilterGroup({
  title,
  options,
  active,
  onSelect,
}: {
  title: string;
  options: string[];
  active: string;
  onSelect: (v: string) => void;
}) {
  return (
    <div className="mb-6 last:mb-0">
      <h3 className="font-heading font-bold text-sm text-foreground-900 mb-3">{title}</h3>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onSelect('')}
          className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
            active === ''
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-700 hover:bg-background-200'
          }`}
        >
          全部
        </button>
        {options.map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onSelect(opt)}
            className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
              active === opt
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200'
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function CategoryFilter({
  subcategories,
  state,
  onSelect,
  onReset,
}: CategoryFilterProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2">
          <span className="w-5 h-5 flex items-center justify-center text-primary-500 text-lg">
            <i className="ri-filter-3-line"></i>
          </span>
          筛选条件
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          重置
        </button>
      </div>

      {subcategories.length > 0 && (
        <FilterGroup
          title="细分子类别"
          options={subcategories}
          active={state.sub}
          onSelect={(v) => onSelect('sub', v)}
        />
      )}
      <FilterGroup
        title="难度等级"
        options={levelOptions}
        active={state.level}
        onSelect={(v) => onSelect('level', v)}
      />
      <FilterGroup
        title="课程时长"
        options={durationOptions}
        active={state.duration}
        onSelect={(v) => onSelect('duration', v)}
      />
      <FilterGroup
        title="费用类型"
        options={priceTypeOptions}
        active={state.price}
        onSelect={(v) => onSelect('price', v)}
      />
    </div>
  );
}